import { createStructuredSelector } from "reselect";
import { getAccountSelectedHistoryInfo } from "../../../modules/Account/accountSelectors";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { useEffect, useMemo } from "react";
import { MOBILE_HISTORY_INFO_TYPES } from "./mobileHistoryConstants";
import MobileHistoryTransactionInfo
    from "./MobileHistoryTransaction/MobileHistoryTransactionInfo/MobileHistoryTransactionInfo";
import { loadAccountHistoryInfoAction } from "../../../app/appActions";
import { Loader } from "../../../components/Loader/Loader";
import MobileHistoryPositionInfo from "./MobileHistoryPosition/MobileHistoryPositionInfo/MobileHistoryPositionInfo";
import { getUserSelectedAccountCode } from "../../../app/appSelectors";

function MobileHistoryInfo(props) {
    const {loadAccountHistoryInfo, selectedHistoryInfo, selectedAccountCode} = props;
    const location = useLocation();

    const {type, id} = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const type = searchParams.get('type');
        const id = searchParams.get('id');
        return {type, id};
    }, [location.search]);

    useEffect(() => {
        if (id && type && selectedAccountCode && !selectedHistoryInfo[type]) {
            loadAccountHistoryInfo({id, type, accountCode: selectedAccountCode});
        }
    }, [id, loadAccountHistoryInfo, selectedAccountCode, selectedHistoryInfo, type]);

    if (!selectedHistoryInfo[type]) {
        return <Loader show/>
    }

    return <>
        {type === MOBILE_HISTORY_INFO_TYPES.POSITION && <MobileHistoryPositionInfo/>}
        {type === MOBILE_HISTORY_INFO_TYPES.TRANSACTION && <MobileHistoryTransactionInfo/>}
    </>
}

const mapStateToProps = createStructuredSelector({
    selectedAccountCode: getUserSelectedAccountCode,
    selectedHistoryInfo: getAccountSelectedHistoryInfo,
});

const mapDispatchToProps = (dispatch) => ({
    loadAccountHistoryInfo: payload => dispatch(loadAccountHistoryInfoAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileHistoryInfo);
